
import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./header";
import { VoteFooter } from "@/components/voting/vote-footer";
import { AnimatedBackground } from "../ui/animated-background";
import { Toaster } from "@/components/ui/sonner";
import { isStandalone } from "@/utils/device";
import { LanguageProvider } from "@/contexts/language-context";
import "@/styles/pwa-safe-areas.css";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const isPWA = isStandalone();
  const location = useLocation();
  
  // Check if we're on a game voting page
  const isVotingPage = location.pathname.includes('/game/');
  
  // Listen for live changes in color scheme preference
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      if (e.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  
  return (
    <LanguageProvider>
      <div className="flex flex-col min-h-screen relative overflow-hidden">
        <AnimatedBackground />
        <Header className={isPWA ? 'safe-area-header' : ''} />
        <main className={`flex-1 relative z-0 text-start ${isPWA ? 'safe-area-content' : ''}`}>
          {children}
        </main>
        {/* Hide footer on voting pages */}
        {!isVotingPage && (
          <div className="flex justify-center w-full py-8 border-t bg-background/80 backdrop-blur-lg">
            <VoteFooter />
          </div>
        )}
        <Toaster />
      </div>
    </LanguageProvider>
  );
}
